import React, { useState } from 'react'
import CardPortfolio from '../CardPortfolio/CardPortfolio'
import './portfolio.css'
import {portfolio} from '../../data'
import { useEffect } from 'react';

function Portfolio() {
  const [Categoria, setCategoria] = useState([])
  const [botonActivo, setBotonActivo] = useState('web')

  const filter =(categoria)=>{
    const portfolioFiltrado = portfolio.filter(item=>item.categoria===categoria)
    setCategoria (portfolioFiltrado)
    setBotonActivo(categoria)
  }

  useEffect(() => {
    filter('web')
  }, [])// eslint-disable-line react-hooks/exhaustive-deps
  


  return (
    <section className='portfolio' id='portfolio'>
      <h2 className='portfolio-title'>Portfolio</h2>
      <div className='portfolio-filter'>
        <button onClick={()=>filter('web')}  className={botonActivo === 'web' ? 'portfolio-filter-buttons active-filter' : 'portfolio-filter-buttons'}>Páginas Web</button>
        <button onClick={()=>filter('app')}  className={botonActivo === 'app' ? 'portfolio-filter-buttons active-filter' : 'portfolio-filter-buttons'}>App Web</button>
        <button onClick={()=>filter('proyecto')}  className={botonActivo === 'proyecto' ? 'portfolio-filter-buttons active-filter' : 'portfolio-filter-buttons'}>Proyectos</button>       
      </div>
      <div className='portfolio-proyects'>
        {Categoria.map(item=> <CardPortfolio key={item.id} titulo={item.nombre} link={item.link} repositorio={item.repositorio} img={item.img} tecnologias={item.tecnologias} descripcion={item.descripcion}/>)}
      </div>
    </section>
  )
}

export default Portfolio